import * as types from '../constants/ActionTypes';
import { setFieldsDetail } from '../../lib/emailUtil';

const initialState = {
  isLoading: false,
  error: false,
  display: false,
  topicName: '',
  fields: [],
  isLogoutForm: false,
  isMessageSending: false,
  isPrivacyWebFormEnabled: false,
  retryCount: 0,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_TOPIC_DATA:
      return { ...state, isLoading: true };
    case types.RECEIVE_TOPIC_DATA_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: false,
        display: false,
        isLogoutForm: false,
        retryCount: state.retryCount + 1,
      };
    }
    case types.RECEIVE_EMPTY_FIELDS_NO_INTENT:
      return {
        ...state,
        isLoading: false,
        error: false,
        display: false,
        isLogoutForm: false,
      };
    case types.RECEIVE_EMAIL_ERROR_NO_INTENT:
      return {
        ...state,
        isLoading: false,
        error: true,
        display: false,
        isMessageSending: false,
      };
    case types.SELECT_RESULT:
      return {
        ...state,
        topicName: action.payload.topicName,
        subTopicName: action.payload.topicName,
        fieldPrefix: action.payload.topicId,
        fields: [],
      };
    case types.RECEIVE_FORM_FIELDS_NO_INTENT:
      return {
        ...state,
        isLoading: false,
        kanaCode: action.payload.kanaCode,
        fields: setFieldsDetail(state.fieldPrefix, action.payload.formFields),
        error: false,
        display: false,
        retryCount: 0,
        topicRefId: action.payload.topicRefId,
      };
    case types.REQUEST_BY_EMAIL_NO_INTENT:
      return { ...state, display: true };
    case types.PRESERVE_FIELD_DATA_NO_INTENT:
      return { ...state, fields: action.payload };
    case types.CANCEL_EMAIL_FORM_NO_INTENT:
    case types.LOGIN_EMAIL_NO_INTENT:
      return { ...state, display: false };
    case types.RECEIVE_EMAIL_RESPONSE_NO_INTENT:
      return { ...state, display: false, isMessageSending: false };
    case types.REQUEST_TOPIC_TREE:
      return { ...state, isLogoutForm: false };
    case types.ACCESS_LOGOUT_EMAIL:
      return { ...state, isLogoutForm: true };
    case types.UPDATE_LOGOUT_EMAIL_TOPIC:
      return {
        ...state,
        topicName: action.payload && action.payload.topic_name,
        subTopicName: action.payload && action.payload.topic_name,
        fieldPrefix: action.payload && action.payload.topic_id,
      };
    case types.PROVIDE_PPM_EMAIL_FIELDS:
      return {
        ...initialState,
        fieldPrefix: action.payload.refId,
        topicName: action.payload.topicName,
        subTopicName: action.payload.topicName,
        isLoading: false,
        kanaCode: action.payload.refId,
        fields: setFieldsDetail(action.payload.refId, action.payload.formFields),
        error: false,
        display: true,
        topicRefId: action.payload.refId,
        isLogoutForm: true,
      };
    case types.SEND_EMAIL_NO_INTENT:
      return {
        ...state,
        isMessageSending: true,
      };
    case types.DISPLAY_LOGOUT_WEB_FORM:
      return {
        ...state,
        isPrivacyWebFormEnabled: true,
      };
    default:
      return state;
  }
}
